<template>
    <div class="accordion">
        <div v-for="(item,index) in data" :key="index">
            <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
                <ion-card v-if="show"
                          mode="ios"
                          style="margin: 0 0 10px 0px">
                    <ion-item class="accordion-header" @click="headerClicked">
                        <ion-label mode="md" class="ion-text-wrap">
                            <h3 class="accordion-title">{{ item.question }}</h3>
                            <svg class="icon icon-chevron-right">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </ion-label>
                    </ion-item>
                    <ion-card-content class="panel">
                        <div class="panel-body">
                            <slot :item="item"></slot>
                        </div>
                    </ion-card-content>
                </ion-card>
            </slide-x-left-transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accordion",
        props: ["data"],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            headerClicked(e) {
                e.currentTarget.children[0].classList.toggle("active");

                // close all panels, except on that was clicked
                let panels = document.getElementsByClassName("panel");
                Array.from(panels).forEach(item => {
                    if (e.currentTarget.nextElementSibling !== item) {
                        item.style.maxHeight = null;
                        item.previousElementSibling.children[0].classList.remove("active");
                    }
                });

                // toggle
                let panel = e.currentTarget.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }

                this.$forceUpdate();
            }
        }
    };
</script>